import { WebPlugin } from '@capacitor/core';
export class ThaiIDReaderWeb extends WebPlugin {
    async reader() {
        throw this.unimplemented('reader() Not implemented on web.');
    }
    async findReader() {
        throw this.unimplemented('findReader() Not implemented on web.');
    }
    async getNameReader() {
        throw this.unimplemented('getNameReader() Not implemented on web.');
    }
    async powerOn() {
        throw this.unimplemented('powerOn() Not implemented on web.');
    }
    async close() {
        throw this.unimplemented('close() Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map